import { render, staticRenderFns } from "./ProductEdit.vue?vue&type=template&id=043e4388&scoped=true&lang=pug&"
import script from "./ProductEdit.vue?vue&type=script&lang=js&"
export * from "./ProductEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043e4388",
  null
  
)

export default component.exports